import { render } from "./NotificationResponseCounterAndReminder.vue?vue&type=template&id=3b373c5c&scoped=true&ts=true"
import script from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"
export * from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"

import "./NotificationResponseCounterAndReminder.vue?vue&type=style&index=0&id=3b373c5c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b373c5c"]])

export default __exports__